import { render } from "./SettingLayout.vue?vue&type=template&id=a34b521c"
import script from "./SettingLayout.vue?vue&type=script&lang=js"
export * from "./SettingLayout.vue?vue&type=script&lang=js"

import "./SettingLayout.vue?vue&type=style&index=0&id=a34b521c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__